import { Map } from 'immutable'

const initialState = Map({
  global: Map({
    q: '',
    collection_id: null,
    sort_by: null,
    filter_by: null
  })
})

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FILTER_SEARCH_QUERY':
    {
      const key = action.payload.key
      const previousValue = state.get(key)
      const value = previousValue ? previousValue.merge({ q: action.payload.value }) : { q: action.payload.value }

      return state.merge({ [key]: value })
    }
    case 'SET_FILTER_COLLECTION':
    {
      const key = action.payload.key
      const previousValue = state.get(key)
      const value = previousValue ?
        previousValue.merge({ collection_id: action.payload.value }) :
        { collection_id: action.payload.value }

      return state.merge({ [key]: value })
    }
    case 'SET_FILTER_SORT_BY':
    {
      const key = action.payload.key
      const previousValue = state.get(key)
      const value = previousValue ?
        previousValue.merge({ sort_by: action.payload.value }) :
        { sort_by: action.payload.value }

      return state.merge({ [key]: value })
    }
    case 'SET_FILTER_FILTER_BY':
    {
      const key = action.payload.key
      const previousValue = state.get(key)
      const value = previousValue ?
        previousValue.merge({ filter_by: action.payload.value }) :
        { filter_by: action.payload.value }

      return state.merge({ [key]: value })
    }
    case 'SETTINGS_INITIALIZED':
    {
      const settings = action.payload.settings

      return state.map(
        (key) => key.merge({ sort_by: settings['store.default_sort'], filter_by: settings['store.default_filter'] })
      )
    }
    default:
      return state
  }
}
